import React, { useMemo } from "react";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { useFormikContext } from "formik";
import { getTotalTaxAndAmountADDSaleOrder } from "../../utilities/functions";

function TotalInfo() {
  const { language, translations } = useLanguage();
  const t = translations[language];

  const { values } = useFormikContext();

  const { totalAmount = 0, totalTax = 0 } = useMemo(
    () => getTotalTaxAndAmountADDSaleOrder(values?.order_line || []),
    [values]
  );
  return (
    <div className="right_side_div ">
      <div>
        {t["Untaxed Amount"]}:
        <span className="right_side_amount">{totalAmount?.toFixed(2)}</span>{" "}
      </div>
      <div>
        {t["Taxes"]}: <span className="tax_div">{totalTax.toFixed(2)}</span>
      </div>
      <div className="total_amount_div">
        {t["Total Amount"]}:{" "}
        <span className="amount_div">
          {(totalAmount + totalTax).toFixed(2)}
        </span>
      </div>
    </div>
  );
}

export default TotalInfo;
